import React, { useContext } from 'react';
import { style } from 'typestyle';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import * as styles from './modal.styles';
import PrimaryButton from '../../../core/components/buttons/primary-button.component';
import Column from '../../../core/components/column/column.component';
import { MainAxisAlignment } from '../../../core/components/flex/flex.component';
import Row from '../../../core/components/row/row.component';
import { IsMobileContext } from '../../../core/context/is-mobile';

interface Props {
  readonly showModal: boolean;
  readonly isLoading?: boolean;
  readonly itemName: string;
  readonly handleClose: () => void;
  readonly handleAccept: () => void;
  /** Overrides the default removal wording for confirmations that aren't deletions. */
  readonly messageKey?: string;
  /** Overrides the default "Delete" label on the confirm button. */
  readonly confirmLabelKey?: string;
}

const ConfirmationModal = ({
  showModal,
  isLoading,
  itemName,
  handleClose,
  handleAccept,
  messageKey,
  confirmLabelKey,
}: Props): React.JSX.Element => {
  const isMobile = useContext(IsMobileContext);
  const { t } = useTranslation();
  return (
    <Modal ariaHideApp={false} isOpen={showModal} onRequestClose={handleClose} style={styles.modalStyle(isMobile)}>
      <Column>
        <span className={style(styles.bodyText)}>
          {messageKey ? t(messageKey) : t('about-to-remove')} {itemName}
        </span>
        {!messageKey && <span className={style(styles.bodyText)}>{t('are-you-sure')}</span>}

        <Row itemSpacing={12} mainAxisAlignment={MainAxisAlignment.Stretch}>
          <div className={style(styles.button)}>
            <PrimaryButton
              fullWidth
              onClick={(): void => {
                handleAccept();
              }}
              loading={isLoading}
            >
              {t(confirmLabelKey ?? 'delete')}
            </PrimaryButton>
          </div>
          <div className={style(styles.button)}>
            <PrimaryButton fullWidth onClick={handleClose}>
              {t('cancel')}
            </PrimaryButton>
          </div>
        </Row>
      </Column>
    </Modal>
  );
};

export default ConfirmationModal;
